import { toRefs, reactive, watch } from "vue"

import cartService from "./cartService"
import customerService from "./customerService"

import firebaseService from "./firebaseService"
const firebase = firebaseService()


import companyService from "./companyService"




import axios from "axios"
import config from "../../config"
import { getAuthToken } from "./auth"

import { CartItem } from "oido-data-structures"


const unsubscribeHandles = []

async function teardown() {
    for (let unsubscribeHandle of unsubscribeHandles) {
        await unsubscribeHandle()
    }
    //empty it
    unsubscribeHandles.length = 0

}

const state = reactive({
    initialized: false,
    initializing: false,
    error: null,
    paymentIntentRequestSignal: null,
    sessionCheckRequestSignal: null,
    orders: {}
})

async function createPaymentIntent(pointofsaleId) {

    let items = cartService.items ? cartService.items.value : null
    let customerId = customerService.customerId ? customerService.customerId.value : null

    if (!items) {
        throw new Error("createPaymentIntent: no Customer and/or cartitems")
    }
    //make a copy of the items (we modify it before sending )
    items = JSON.parse(JSON.stringify(items))

    // Build the CartItem payload directly from the cart lines. The cart already
    // merges equivalent items (shared Cart class), so each line carries its own
    // quantity — no per-serving expansion or accumulation. Per-serving course/note
    // (serviceInformation) was removed with the courses feature; the server falls
    // back to each product's defaultCourseId for kitchen/receipt grouping.
    let cartItems = []
    for (let item of items) {
        if (!item) continue
        let cartItem = new CartItem(item.id, {})
        cartItem.note = item.note || null
        cartItem.courseId = item.courseId || null
        cartItem.productId = item.productId
        cartItem.quantity = item.quantity
        cartItem.chosen = item.chosen && Object.keys(item.chosen).length > 0 ? item.chosen : null
        cartItem.options = item.options || null
        cartItems.push(cartItem)
    }





    let pointofsale = companyService.getPointofsaleById(pointofsaleId)
    if (!pointofsale) {
        console.log("No point of sale found ", pointofsaleId)
        return
    }

    let company = companyService.company ? companyService.company.value : null
    if (!company) {
        console.log("No company found ", company)
        return
    }

    let deliveryType = cartService.deliveryType ? cartService.deliveryType.value : "takeaway"
    let deliveryZoneId = cartService.deliveryZoneId ? cartService.deliveryZoneId.value : null
    let pickupLocationId = cartService.pickupLocationId ? cartService.pickupLocationId.value : null

    let userSuppliesBillingAddress = cartService.userSuppliesBillingAddress ? Boolean(cartService.userSuppliesBillingAddress.value) : false
    let billingAddress = cartService.billingAddress.value && Object.values(cartService.billingAddress.value).length  > 0 ? cartService.billingAddress.value : null
    let needsBillingAddress = Boolean(cartService.billingAddress.value)

    //delete any billingaddress in case it shouldn't be there (needed if the user hid a usersupplied billing address
    if (!userSuppliesBillingAddress && !needsBillingAddress) {
        billingAddress = null
    }
    let deliveryUsesDifferentAddress = cartService.deliveryUsesDifferentAddress ? Boolean(cartService.deliveryUsesDifferentAddress.value) : false
    let deliveryAddress = cartService.deliveryAddress ? cartService.deliveryAddress.value : null

    //delete any delivery address if it's not needed (because its no delivery, or the user supplied a billing address which acts as delivery address)    
    if (deliveryType != "delivery" || (billingAddress && !deliveryUsesDifferentAddress)) {
        deliveryAddress = null
        deliveryUsesDifferentAddress = false
    }


    let pickupTimeMode = deliveryType != "table" && cartService.pickupTimeMode ? cartService.pickupTimeMode.value : null
    let pickupTime = deliveryType != "table" && cartService.pickupTime ? cartService.pickupTime.value : null
    let note = cartService.note ? cartService.note.value : null
    let paymentType = cartService.paymentType ? cartService.paymentType.value : null


    let collectsPhoneNumber = company.sendSMSOnOrderReady || pointofsale.collectPhoneNumber
    let phone = collectsPhoneNumber && cartService.phone ? cartService.phone.value : null

    let collectsEmail = pointofsale.collectEmail
    let email = collectsEmail && cartService.email ? cartService.email.value : null

    let voucher = cartService.voucher ? cartService.voucher.value : null
    let discounts = cartService.discounts ? cartService.discounts.value : null

    if (paymentType == "online" && !pointofsale.enableOnlinePayment) {
        paymentType = null
    }

    if (paymentType == "offline" && !pointofsale.enableOfflinePayment || !company.enableOfflinePayments) {
        paymentType = null
    }

    if (deliveryType == "delivery" && !pointofsale.allowDeliveryOnInvoice) {
        paymentType = null
    }



    if (!paymentType) {
        if (pointofsale.enableOnlinePayment) {
            paymentType = "online"
        } else if (pointofsale.enableOfflinePayment && company.enableOfflinePayments) {
            paymentType = "offline"
        }
    }

    if (!paymentType) {
        console.log('missing payment type')
        return
    }


    // check if a name was collected: only for paymenttype offline because with stripe it will be collected anyway
    let collectsCustomerName = paymentType == 'offline' || pointofsale.collectCustomerName    
    let customerName = collectsCustomerName && cartService.customerName ? cartService.customerName.value : null

    let createCustomerIfNoneExists = Boolean(cartService.createCustomerIfNoneExists.value)


    if (state.paymentIntentRequestSignal) {
        console.log('already requesting paymentIntent')
        return
    }


    let companyId = company ? company.id : null
    let tipPercentage = cartService.tipPercentage ? cartService.tipPercentage.value : 0




    let postData = {
        companyId,
        items: cartItems,
        tipPercentage,
        pointofsaleId,
        zoneId: pointofsale.zoneId,
        deliveryType,
        deliveryZoneId,
        pickupLocationId,
        pickupTimeMode,
        pickupTime,
        note,
        voucher,
        discounts,
        billingAddress,
        deliveryAddress,
        paymentType,
        phone: phone,
        email: email,
        customerName,
        createCustomerIfNoneExists
    }

    // console.log('data',postData);
    // return 


    let isInIframe = window !== window.parent
    //isInIframe = true

    if (isInIframe) {
        var form = document.createElement("form")
        form.setAttribute("method", "post")
        form.setAttribute("action", config.apiUrl + "/api/stripe/paymentIntent")
        postData['isInIframe'] = true
        for (let key in postData) {
            console.log("postData", key, postData[key])
            var hiddenField = document.createElement("input")
            hiddenField.setAttribute("name", key)
            hiddenField.setAttribute("value", typeof postData[key] == "object" ? JSON.stringify(postData[key]) : postData[key])
            form.appendChild(hiddenField)
        }
        form.setAttribute("target", "oido-" + pointofsaleId)
        document.body.appendChild(form) // Not entirely sure if this is necessary          
        form.submit()
        return null
    }


    let authToken = getAuthToken(companyId)


    const abortController = new AbortController()
    state.paymentIntentRequestSignal = abortController.signal

    let response = await axios.post(config.apiUrl + "/api/stripe/paymentIntent", postData, {
        signal: abortController.signal,
        headers: {
            Authorization: authToken ? 'Bearer ' + authToken : undefined
        }
    })
    state.paymentIntentRequestSignal = null


    if (!response || !response.data) {
        throw new Error("createPaymentIntent: invalid responsedata")
    }

    if (response.data.error) {
        console.log(response.data.error, response.data.error)
        throw new Error(response.data.error)
    }

    return response.data.url
}

async function checkOrderState(sessionId) {

    // console.log('loading order', sessionId);

    if (!state.orders || state.orders[sessionId]) {
        console.log('already loaded order', state)
        return
    }

    if (!sessionId) {
        throw new Error("checkOrderState: no sessionId")
    }


    let orderUnsubscribeHandle = firebase
        .firestore()
        .collection("orderInfos")
        .doc(sessionId)
        .onSnapshot((snapshot) => {
            let data = snapshot.data()
            // console.log('orderInfos data', data, snapshot, sessionId)
            if (data && snapshot.id) {
                //remove any cart Content
                // console.log('emptyTheCart')
                cartService.emptyTheCart()
                data.id = snapshot.id
                state.orders[snapshot.id] = data
            }
        })
    unsubscribeHandles.push(orderUnsubscribeHandle)

}



if (!state.initialized && !state.initializing) {
    state.initializing = true
    state.initialized = true
    state.initializing = false
}


export default {
    ...toRefs(state),
    createPaymentIntent,
    checkOrderState

}

